import React, { useState, useEffect } from 'react';
import { makeStyles, Box, Typography, IconButton } from '@material-ui/core';
import icAttachment from '../assets/icons/ic_attachment.png';
import { PrimaryButton } from '../common/button';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslate, useDataProvider } from 'react-admin';
import ListMoviesDialog from './list-movies-dialog';
import ThumbnailIcon from './thumbnail';
import GreenSwitch from '../CustomizedUIs/GreenSwitch';
import { changeNodeGlobalData } from '../redux/actions/tree-action';

const useStyles = makeStyles(theme => ({
    Title: {
        fontFamily: 'UniviaPro-Medium',
        fontStyle: 'normal',
        fontStretch: 'normal',
        fontWeight: 500,
        lineHeight: '13.2px',
        letterSpacing: 'normal',
        color: '#4f5064',
        fontSize: '11px',
        align: "center"
    },
    borderBrowse: {
        borderRadius: '4px',
        backgroundColor: 'rgba(255,255,255,0.5)',
        // opacity: 0.5,
        border: "solid 1px #c1e5fa",
        width: '500px',
        // height: '132px',
        marginTop: '18px'
    },
    listFiles: {
        maxHeight: 400,
        overflow: 'scroll'
    },
    switch: {
        width: 170,
        height: 30,
        backgroundColor: theme.palette.common.white,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-around',
        // marginLeft: '24px'
    },
    switchText: {
        whiteSpace: 'nowrap',
        fontFamily: "UniviaPro-Bold",
        fontSize: "9px",
        fontWeight: "bold",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: '11px',
        letterSpacing: " 0.36px",
        color: "#4f5064",
    }
}));

function GenericMedia() {
    const translate = useTranslate();
    const dataProvider = useDataProvider();
    const dispatch = useDispatch();
    const classes = useStyles();

    const [selecting, setSelecting] = useState(false);
    const { isEditing, nodeSelected } = useSelector(state => state.tree);
    const { nodeApplication } = nodeSelected.applicationData;
    const { mediaGrid } = nodeApplication;
    const { files, enableCategories } = mediaGrid;

    const onToggleEnableCategories = event => {
        onChangeValue('enableCategories')(event.target.checked);
    }

    const onChangeValue = prop => value => {
        const newNode = {
            ...nodeSelected.applicationData,
            nodeApplication: {
                ...nodeSelected.applicationData.nodeApplication,
                mediaGrid: {
                    ...nodeSelected.applicationData.nodeApplication.mediaGrid,
                    [prop]: value
                }
            }
        };
        dispatch(changeNodeGlobalData(newNode));
    }

    const onRemoveFile = (index) => {
        const newFiles = files.filter((_, idx) => index !== idx);
        const newNode = {
            ...nodeSelected.applicationData,
            nodeApplication: {
                ...nodeApplication,
                mediaGrid: {
                    ...mediaGrid,
                    files: newFiles
                }
            }
        }
        dispatch(changeNodeGlobalData(newNode));
    }

    const getFile = () => {
        if (files) {
            var requests = []
            if (files.length > 0) {
                for (let i = 0; i < files.length; i++) {
                    requests.push(dataProvider('GET_ONE', "medias", {
                        id: files[i].id
                    }).then(({ data }) => {
                        files[i].name = data.name
                    }).catch((error) => {
                        console.log('error', error.message)
                    }));
                }
            }
            Promise.all(requests)
                .then(() => {
                    const newNode = {
                        ...nodeSelected.applicationData,
                        nodeApplication: {
                            ...nodeApplication,
                            mediaGrid: {
                                ...mediaGrid,
                                files: files
                            }
                        }
                    }
                    dispatch(changeNodeGlobalData(newNode, false));
                })
                .catch((error) => {
                    console.log('error', error.message)
                })
        }
    }

    useEffect(() => {
        getFile();
    }, [])

    return (
        <Box>
            <Box px={1} className={classes.switch} style={{ marginTop: 25, position: 'relative' }}>
                <Typography className={classes.switchText}>{translate('resources.infoPage.radioItem.enable_categories')}</Typography>
                <GreenSwitch checked={enableCategories} disabled={!isEditing} onChange={onToggleEnableCategories} size='small' style={{ color: 'white' }} />
            </Box>
            <Box className={classes.borderBrowse} justifyContent='center' alignItems="center" >
                <Box display='flex' width="100%" alignItems="center">
                    <Box mx={2} display='flex' alignItems="center">
                        <IconButton
                            variant="outlined"
                            color='primary'
                            style={{ marginRight: '10px', padding: 'unset' }}
                        >
                            <img src={icAttachment} width={27} />
                        </IconButton>
                        <Typography className={classes.Title}>{translate('pos.channels.mediaFile')}</Typography>
                    </Box>
                    <Box style={{ marginLeft: 'auto' }} mx={2} my={2}>
                        <PrimaryButton
                            disabled={!isEditing}
                            label={files.length > 0 ? translate('pos.common.change') : translate('pos.common.browse')}
                            onClick={() => setSelecting(true)}
                        />
                        <ListMoviesDialog

                            open={selecting}
                            onClose={() => setSelecting(false)}
                        />
                    </Box>
                </Box>
                <Box className={classes.listFiles}>
                    {
                        files.map((file, index) => (
                            <ThumbnailIcon
                                thumbnail={file}
                                onClear={() => onRemoveFile(index)}
                            />
                        ))
                    }
                </Box>
            </Box>
        </Box>
    )
}

export default GenericMedia;
